var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsMx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 45,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CE1126",
    d: "M40 0h20v45H40V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 0h20v45H20V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006847",
    d: "M0 0h20v45H0V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M33.4 27.1v.5l.1-.2v-.3h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "m33.4 27 .2.5h-.2v-.4Zm0 .1v.4h.1l-.1-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M33.3 27.1a.1.1 0 1 0 0-.2.1.1 0 0 0 0 .3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M33.3 26.9a.1.1 0 1 0 0 .2.1.1 0 0 0 0-.2Zm-.1.1a.1.1 0 1 1 .3 0 .1.1 0 0 1-.3 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "m33.9 27.8-.3-.3-.2.1.4.3v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "m33.6 27.5.3.3-.5-.2.2-.1Zm-.2.1.4.2-.2-.3-.2.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M33.8 28v-.2h.2c.1 0 0 .1 0 .2h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M33.9 27.8s-.1.1 0 .2h.1v-.2Zm.2 0h-.2c-.1 0-.1.1 0 .2h.1s.1-.2 0-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "m36.2 23.4.3.3v-.1l-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "m36.3 23.3.3.2v.2l-.4-.3Zm0 .1.2.3v-.1l-.2-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M36.2 23.4a.1.1 0 1 0 0-.2.1.1 0 0 0 0 .2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M36.2 23.2a.1.1 0 1 0 0 .2.1.1 0 0 0 0-.2Zm-.2.1a.1.1 0 1 1 .3 0 .1.1 0 0 1-.3 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "m37 23.6-.4.1v-.1h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M37 23.5v.1l-.5.1.1-.2h.4Zm-.4 0v.2l.4-.1h-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M37.1 23.6a.1.1 0 1 0 0-.2.1.1 0 0 0 0 .2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M37.1 23.4a.1.1 0 1 0 0 .2.1.1 0 0 0 0-.2Zm-.1.1a.1.1 0 1 1 .3 0 .1.1 0 0 1-.3 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "m35.4 26-.3-.5.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "m35.2 25.5.3.4-.4-.4Zm0 0 .2.4-.2-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M35.1 25.5a.1.1 0 1 0 0-.2.1.1 0 0 0 0 .2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M35.1 25.3a.1.1 0 1 0 0 .2.1.1 0 0 0 0-.2Zm-.1 0a.1.1 0 1 1 .3 0 .1.1 0 0 1-.3 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M35.4 26h.4l-.3-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "m35.5 25.8.3.2h-.4l.1-.2Zm0 0v.2h.3l-.3-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M36 26.2a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M36 26a.1.1 0 1 0 0 .2.1.1 0 0 0 0-.3Zm-.2 0a.1.1 0 1 1 .3 0 .1.1 0 0 1-.3 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "m26.7 27-.1.1-.1-.1v-.1l.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M26.5 27v.1h.1v-.2Zm.2 0-.1-.1-.1.1v.1h.2V27Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M26.7 27.2v.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M26.7 27.2v.5l-.1-.5Zm0 0v.4-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "m26.8 27-.1.3c-.1 0-.3 0-.3-.2h.2s.1-.1.2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M26.7 27v.1h-.2v.1h.2s.1-.1 0-.1Zm0 0h-.4v.1l.1.2h.2v-.1c.1 0 .1-.1 0-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "m26 27.9.1-.1-.1-.1h-.2c0 .1 0 .2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M25.9 27.7v.1h.2l-.1-.1h-.1Zm0 0h.2v.2h-.2v-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M26.2 27.8h.5l-.1-.2h-.4v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M26.6 27.6v.1h-.4.4Zm-.4 0v.1h.4-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M26.3 27.7c0 .1 0 .3-.1.2-.2 0-.1 0-.1-.1v-.3l.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M26 27.5v.2a.4.4 0 0 1 0 .1l.1.1h.1v-.3H26Zm.3.2-.1-.2H26l-.1.1v.4h.2v-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M24.8 25.4v-.2h-.1v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M24.7 25.1v.2h.1V25Zm0 0h.2v.2h-.2V25Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M24.8 25.5v.5l-.1-.1v-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M24.7 25.5h.1v.5l-.1-.1v-.4Zm0 0v.4-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M25 25.4c0 .1-.2.2-.3.1l-.1-.1c0-.1.1-.1.2 0 0 0 .1-.1.2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M24.6 25.3v.2a.3.3 0 0 0 .3 0v-.1h-.4Zm0 0h.4v.2h-.4v-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M24 26h.2l-.2-.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M23.9 25.9h.2-.2Zm0 0h.2v.1h-.2v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "m24.3 26 .3-.1.2.1h-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "m24.6 25.9.2.1h-.5l.3-.1Zm-.3 0h.4-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "m24.2 25.7.1.3-.2.1v-.4Zm-.3-2.6h-.2V23s.1-.1.2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M23.8 23v.2-.1l.1-.1Zm0 0h.1c0-.1 0 0 0 0h-.2v.2h.1l.1-.1Zm.3 2.8v.4c.1 0 .2 0 .2-.2v-.1h-.1Zm0 0h.2v.2l-.2.1v-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "m23.5 23.8.2-.5-.3.3.1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "m23.7 23.3-.2.5v-.2l.2-.3Zm-.2.3v.1l.2-.4-.2.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M23.7 23.3c-.1 0-.2-.1-.1-.2h.2v.1c.1 0 .1.1 0 .1h-.1Zm-.8 0v.1h-.1s-.1 0 0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M23.6 23.1v.2h.4v-.1h-.1l-.1-.1h-.1Zm0 0h.2l.1.1v.1h-.3V23Zm-.9.2.2.1v-.1h-.1Zm.2 0h-.2v.1h.2v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "m23 23.5.4.2v.1l-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "m23 23.4.4.3v.2l-.4-.4Zm0 0v.1l.4.3v-.1l-.3-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M23 23.5h-.2l.1-.1v-.1h.2v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M23 23.2v.1l-.2.2h.4v-.2Zm0 .3.1-.2h-.2v.1c0 .1-.1.1 0 .1h.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    d: "M33.4 27.2v.1-.1Zm0-.1h-.2v-.2.2h.2Zm.4.7-.4-.2.4.2Zm.3 0-.1.2h-.1v-.2.2h.1v-.1Zm2.2-4.4v.1-.1Zm0-.1-.2.1v-.1.1h.2v-.1Zm1 .2-.2.1v-.1H37v.1h.2v-.1Zm-.3 0-.1.1h-.1.2Zm-1.7 2.1v.2l-.1-.3.1.1Zm0-.2H35v-.1.2h.2s0-.1 0 0Zm.5.6h-.2.2Zm.2 0v.1l-.2-.1v.1h.2Zm-9.2 1-.1.2h-.2.2V27Zm-.1.3v.1-.1Zm-.4.4h.1-.1Zm0 0v.1l-.1.1a.1.1 0 0 1-.1 0v-.1.1h.1v-.1Zm-.5 0 .1.1h.2-.2Zm-.9-2.3-.1.1h-.2v-.1l.1.1h.2v-.1Zm-.1.2h-.1Zm-.5.3.4.1h-.4Zm0 0c0 .1 0 .2-.2.2V26v.1h.1l.1-.1Zm-.2 0h-.2.2Zm-.2-2.7v.1h-.2l-.1-.1v.1h.4Zm-.3.2v.1-.2Zm-.5 0v.1l.3.3-.4-.3h.1Zm0 .1h-.2.1Zm-.2-.1h-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9CA168",
    d: "M37.5 22.5c0 .4-.4.6-.6.7l-.3.3v1l.2-.2h.2s-.2.1-.2.3l-.5.9-.6.1v.1l-.2.2v.1h-.2v.4l-.1.2h.2c0 .1 0 .5-.4.7-.3.2-1.2.2-1.2.2h-.2l-.1.2-.2.2-.2.2-.3.2h.3l.3.1H33c0 .1-.7.5-1 .5-.3 0-.8-.5-.8-.5l-.2-.1h-.3l-.4-.1V28h1.1l.6-.4.5-.2h.3l.1.1-.2.2h.5l.4-.4h.1l.2-.4v-.1l.4-.4.2-.3.1-.3.1.3v.2l.4-.2h.2l.2-.2v-1.1l.3-.5.3-.3v.2l.3-.3.1-.2v-.8l-.2-.4v-.7l.2.2.1.5.3-1 .2.3v.3l.2-.2.2.6Zm-6.3 6.1-.4-.3-.5-.2v.1l.5.3.2.1h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#717732",
    d: "m33.3 27.7.4-.3h.3l.6-.3c.5-.3.5-.5.6-.6h.2l-.3.3-.5.4-.7.2c-.2 0-.3 0-.4.2l-.2.2Zm1.1-1.2-.5.7.6-.5.5-.3.2-.3s0-.2-.8.4Zm-.8.8s.2 0 .3-.2v-.3l.6-.5c.2-.3.1-.5.1-.5v.2c-.1.2-.7.5-.7.7v.3c-.1.3-.3.3-.3.3Zm-.2 1-.4-.1c-.5 0-.9.3-1.2.3-.3 0-.4-.1-.6-.3-.3-.2-.9-.1-.9-.1h.6c.3.1.5.5 1 .5.4 0 .8-.4 1-.4l.5.1Zm-2.3-.2s.4 0 .7-.2l.7-.4h.4l-.4-.1a1 1 0 0 0-.6.1l-.4.4-.4.2Zm0 .5h-.2l-.2-.2-.4-.1.4.1.2.2.2.1v-.1Zm.2-.4h.4c.5 0 .8-.3 1.1-.4h.5a.7.7 0 0 0-.4-.1c-.5 0-1 .3-1.2.4l-.4.1Zm5.3-3.7-.6.9-.3.2-.3.4s-.1 0 0 0l.3-.3.5-.4.5-.9.3-.2-.4.3Zm-.9 1 .1-.2c.2-.2.2-.1.3-.4l.2-.6.2-.5-.2.2-.5.8v.7Zm-.1.2v-1.1l.6-.7s-.2 0-.4.3c-.3.1-.4.4-.4.6l.1.6v.3Zm1-1.9v-.4l.3-.4c.2-.1.3-.2.3-.4v-.7.1l-.1.6c0 .2-.3.5-.4.6v-.5l.2-.6v-.6s0 .2-.2.3v1.6l-.1.2v.3Zm-.4-2 .1.4v.6l.2.3v.3-.7l-.1-.6c0-.2-.2-.3-.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9CA168",
    d: "m28.8 28.6.2-.3.7-.2v.1l-.2.1-.2.1-.3.2h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9CA168",
    d: "M29.4 28h-.6l-.2-.1-.1.2-.5-.5v.5l-.6-.5v.3l-.4-.2h-.1l.1.3h-.5l-.1.2h.3s.3-.1.4 0c.2 0-.2.2-.2.3h.4s.3-.3.4-.2c0 .1-.3.2-.2.4h.3l.4-.3c0 .1-.2.2-.1.3h.3l.3-.4h.1l.2-.1.3-.1h.4V28l-.3-.1Zm-2.6 0 .1-.2-.3-.2-.1-.2-.3-.1V27H26l-.2-.6-.2.3-.1-.3V26h-.2v.2l-.3-.4v.2l-.6-.5V25h-.2v-.6l-.3.3v-.5h-.1l-.1.2-.2-.2v-.5l-.1-.4V23s0 .1 0 0c0 0 .4-.3.3-.4 0-.1-.4.2-.3 0 0-.2.4-.2.4-.5h-.3s.2-.2.1-.3v-.2l-.2.2h-.2v.2l-.1.3-.3-.2v.3l.1.3h-.2l.1.2.2.2.1.1.2.2v.6c-.1 0 0 .2 0 .2H23c0 .1 0 .3.2.3s.5.1.4.2c0 0-.4-.2-.4 0a.4.4 0 0 0 .3.3h.4c0 .2-.3 0-.3.2l.2.1h.3l.4.5.4.3h-.2s.6.3.4.4c-.2 0-.4-.2-.4 0l.2.3h.5c0 .2-.5 0-.5.2l.4.3c.1 0 .3-.2.3 0 .1 0 0 0 0 .1h.5l.5.1.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#717732",
    d: "m29 28.5.3-.1.4-.2-.4.2-.3.2h-.2.1Zm.7-.4h-.1l-.3-.1c-.1 0-.2 0-.3.2h-.2c0 .1.1 0 .2 0l.4-.1h.3Zm-4.7-2h-.2l-.5-.5.3.3.3.3Zm3.3 2.4.2-.2.1-.2V28v.1l.1.1h.2c0-.1 0 0-.1 0l-.3-.3v.2c-.2 0-.2-.4-.5-.5l-.2.1.1.3s-.3-.4-.5-.4l-.2.1.2.2c0 .2-.3-.1-.4-.1h-.2v.2h-.2l-.2.3s.1-.2.3-.2h.5-.1l-.1-.2.1.1.2.1h.2l-.1.2-.2.1.2-.1.2-.1h.1V28l-.2-.2.2.2.1.2h.1v.2l-.1.2.1-.2.2-.1h.1V28l-.1-.2v.2l.2.2h.1v.3Zm-2-1.1h.2s-.2 0-.2-.2l-.1-.4-.2.2v-.6c-.1-.2-.3-.3-.3-.2 0 0 0 .4-.2.3V26c0-.1 0-.2-.2-.2v.3l-.1-.2H25v-.1l-.1.1v.2h.1v.1h-.2.1l.2.1.1.2V26l.1.3v.3H25l.6.2.2.2v-.6l.1.3v.3l-.2.1h-.4.5l.2.2h-.2.2V27v.3h.2Zm-3-3.4.1-.3c0-.2 0-.4-.2-.5l.1-.2v.1H23v-.2l-.1-.1a1 1 0 0 1-.3-.2l.3.2h.4l.2-.2-.2.1H23v-.3c-.2-.1-.2-.3-.2-.3l.1.2.1.1h.2l.3-.3-.3.2h-.1v-.6.2l.4-.3s0-.1 0 0h-.3c-.1 0-.2 0-.2.2v.3l-.3-.2v.3s.2.3 0 .4c0 0-.2-.3-.3-.1 0 .2.3.4.4.4v.2l.3.1.2.6v.2Zm1.2 1.6v-.9l-.2.2v-.5c0-.2 0-.3-.2-.3 0 0-.1.5-.2.4V24h-.1l-.1.1-.3-.2.3.4v-.2s.1.1 0 .2v.1h-.2.1l.3.1.2.3v-.2l.2-.3v.3l-.1.3h-.3l-.3-.1.3.1h.3l.1.3.1-.2.1-.2v.3h-.1l-.2.1H24l.4.1v.1l.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.5 29.1h-.2c0-.1 0 0 0 0l-.1-.1v-.2l.6-.5v-.5h.4v.7l.7.4v.1h-.1l-.1.1h-.2l-.4-.3-.2-.1-.2.4h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016848",
    d: "M29.9 27.8v.7l-.5.3-.2.2h-.1l-.2.1.4-.4c.2-.3.3-.3.4-.3v-.5h.2Zm.6 1.5.1-.1h.1l-.1-.2h-.3l-.2-.3-.2.1.2.2.3.2h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD202A",
    d: "M30.1 27.8h.2v.6l-.1.3-.4.3-.2.3v-.1c-.1 0-.2 0-.1-.1l.3-.3c.2-.2.3-.3.3-.5v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD202A",
    d: "M31.2 29h-.3l-.2-.1-.4-.2-.1-.2v-.2l.3.3.4.2.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30C2DC",
    d: "m32.3 26.9-.3-.3.8-.3V26h-.3l-.8.2-3.2-.2c-.4 0-.6-.6-.6-.6h-.1v.3a6 6 0 0 1-1.4-.5v.2l.6.5c0 .2-.2.2-.2.2v.1c.1 0 1.2 0 1.2.4 0 .2-.2.2-.2.2v.1s.7 0 .9.2l.4.3a6 6 0 0 0 1.9 0l.8-.4.5-.1v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0872A7",
    fillRule: "evenodd",
    d: "M26.4 25.2c.4.3.9.5 1.3.6v-.1a.8.8 0 0 0 0-.1l.2-.1.2.3.4.3a163 163 0 0 1 4 0 1.1 1.1 0 0 1 .3 0v.2a7.4 7.4 0 0 0-.7.3v.1a1.2 1.2 0 0 0 .2.1v.2h-.1l-.4.1c-.2 0-.4.2-.5.3l-.3.2h-.4a10 10 0 0 1-1.5 0l-.2-.2-.3-.2h-.1a3 3 0 0 0-.6 0V27h-.2v-.1a.7.7 0 0 0 .2 0v-.1h.1c0-.2 0-.2-.2-.3h-.3a4.1 4.1 0 0 0-.6-.2l-.1-.2h.2V26l-.3-.3a5.2 5.2 0 0 0-.3-.1v-.4Zm0 .3a5 5 0 0 1 .6.5v.2h-.2l.1.1h.6l.4.2.2.2v.1h-.2v.1h-.1v.1a6.7 6.7 0 0 1 .7.1h.2l.2.2.2.2h.4a7.4 7.4 0 0 0 1.4 0l.4-.1c.1-.2.3-.3.5-.3a3.7 3.7 0 0 1 .5-.2 1.3 1.3 0 0 1-.1-.1l-.1-.1-.1-.1.1-.1a2.7 2.7 0 0 1 .6-.2V26h-.2l-.8.2-3.2-.2c-.2 0-.4-.2-.4-.3a1.5 1.5 0 0 1-.2-.2h-.1v.2c-.5 0-1-.3-1.4-.5v.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.7 26.5a.2.2 0 1 0 0-.4.2.2 0 0 0 0 .4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0872A7",
    fillRule: "evenodd",
    d: "M26.7 26.2a.1.1 0 1 0 0 .3.1.1 0 0 0 0-.3Zm-.3.1a.2.2 0 1 1 .5 0 .2.2 0 0 1-.5 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.8 25.6a.2.2 0 1 0 0-.4.2.2 0 0 0 0 .4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0872A7",
    fillRule: "evenodd",
    d: "M27.8 25.2a.2.2 0 1 0 0 .3.2.2 0 0 0 0-.3Zm-.3.2a.2.2 0 1 1 .5 0 .2.2 0 0 1-.5 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.5 27a.2.2 0 1 0 0-.3.2.2 0 0 0 0 .4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0872A7",
    fillRule: "evenodd",
    d: "M32.5 26.7a.1.1 0 1 0 0 .3.1.1 0 0 0 0-.3Zm-.3.2a.2.2 0 1 1 .5 0 .2.2 0 0 1-.5 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M25.8 25.1c0 .2.2.4.4.5l.3-.1a.3.3 0 0 0 0-.3c-.2-.1-.6-.2-.7 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.3 25.3-.2-.1h-.2l.3.2h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M28 27c0 .2-.2.2-.3.3l-.4-.1c-.1-.1 0-.3.2-.3l.4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27.6 27 .1.2.1-.2h-.2l-.2.2.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M32.7 26.3c.2.2.4 0 .4 0s.3-.2.2-.3H33l-.3.1v.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m32.8 26.3.1-.2h.3l-.1.1h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9AA51",
    d: "m30.2 26-.1-.1h-.6l.3.9.4.5h.5l-.1-1-.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#953220",
    fillRule: "evenodd",
    d: "M29.8 25.8h.3v.1h.1l.4.4.1 1v.1h-.5l-.4-.6-.3-1h.3Zm.4.1h-.7l.4.9.3.5h.4v-1l-.4-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9AA51",
    d: "M29.1 26v-.1h.4l.3.4.3.6c0 .2.3.5.3.5h-.6l-.5-1-.2-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#953220",
    fillRule: "evenodd",
    d: "M29.5 25.9h-.3v.6l.6.8h.5a8.3 8.3 0 0 1-.3-.4l-.1-.3-.1-.3a1.9 1.9 0 0 0-.3-.4Zm0 0h-.4l.1.6.6.8.2.1h.4a4.8 4.8 0 0 1-.3-.5l-.2-.3v-.3a2 2 0 0 0-.3-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9AA51",
    d: "M28.9 25.9h.2c.2 0 .3.3.4.5.1.2 0 .3.2.5l.3.5h-.6l-.3-.1-.2-.1h-.2v-1.3h.2Zm2.2.1-.4-.1h-.6v.3l.3.7.2.5.5-.1h.2V26H31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#953220",
    fillRule: "evenodd",
    d: "M30 25.8h.7l.4.2h.2v1.2h-.2v.1a3 3 0 0 1-.4.1h-.1a2.5 2.5 0 0 1-.1-.3l-.1-.2c-.2-.2-.2-.5-.3-.7v-.3Zm1 1.5h.3V26H31l-.4-.2H30v.3l.3.7.1.2a12 12 0 0 0 .2.3h.2a2.9 2.9 0 0 0 .2-.1Zm-2-1.5h.2l.4.6.1.2v.3a2.2 2.2 0 0 0 .4.5M29 25.8h-.2v1.5h.2l.2.1h.2l.1.1a2.1 2.1 0 0 0 .6 0M29 26h-.2v1.2h.2l.2.2h.3a2.1 2.1 0 0 0 .5 0 2 2 0 0 1-.2-.3l-.1-.3-.1-.3-.4-.5H29Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9AA51",
    d: "m28.8 26 .1.1.1-.1c0-.1 0-.2-.2-.2l-.2.2v.6l.1.3-.1.2c0 .2 0 .3.2.3l.3-.2-.2-.2-.1.1m2.4-1H31c0-.2.1-.2.2-.2l.2.2v.5l-.1.3.1.2c0 .2 0 .3-.2.3 0 0-.2 0-.2-.2l.1-.2.1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#953220",
    fillRule: "evenodd",
    d: "M28.6 25.8h.4v.3h-.2.1v-.3h-.3v1a.6.6 0 0 0 .1 0v.1-.1a.5.5 0 0 1-.1-.5v-.5Zm.1 1.1-.1.2c0 .2 0 .2.2.2h.2V27h-.2l.1-.1h.1v.5h-.2c-.1 0-.3 0-.3-.2l.1-.2m2.5-1v.2-.2h.1v.1c-.1 0-.2 0-.2-.2v.1h.4v.2a.4.4 0 0 1 0 .3v.2a.5.5 0 0 1 0 .3.3.3 0 0 1 0 .2v.3H31l-.1-.2v-.1h.2-.2v.2h.4v-.2a.2.2 0 0 0 0-.2h-.1m0 0a.5.5 0 0 0 0-.3v-.2a.4.4 0 0 0 .1-.3V26H31m.2.9",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#953220",
    d: "M29 27v.1l.1.1.9.1h.8l.2-.2v.2l-.2.1H29V27Zm1.9-1v.2l-.1.3h-.6v-.2l.7-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "m32.5 25.9-.1-.1s-.1-.2 0-.2v.3Zm1-.3v.1h.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M33.7 25.7h-.1s-.1 0 0 0c0-.1 0-.1 0 0h.1Zm.5-.4H34h.2Zm-.7-1h-.1v.2l.1-.2Zm-.5.3c-.1.1-.1.2 0 .2v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CBEBF",
    d: "m32.1 25.2-.2.2s.6.4 1 .4c.5 0 1-.4 1.1-.5v-.5c-.1-.1-.4-.4-.6-.4l-.5.4c-.2.2-.2.4-.5.4h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    fillRule: "evenodd",
    d: "m33.9 24.7.1.2a1.4 1.4 0 0 1 0 .4v.1a2 2 0 0 1-1 .4 2 2 0 0 1-.8-.2 3.6 3.6 0 0 1-.3-.1l.2-.4h.5l.1-.1.2-.2a2.4 2.4 0 0 1 .4-.3h.3a1.2 1.2 0 0 1 .3.2Zm-1.8.5-.2.2a3.2 3.2 0 0 0 .3.2c.3 0 .5.2.8.1.2 0 .4 0 .6-.2a1.9 1.9 0 0 0 .4-.2 1.1 1.1 0 0 0 0-.5h-.2a1.6 1.6 0 0 0-.2-.3h-.4c0 .2-.2.2-.3.3a1 1 0 0 0-.1.2l-.2.2h-.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C8489",
    d: "m32 25.3 1-.1.5-.6h.3l.2.2v.5l-.2.2-.4.1-.3.1h-.3l-.7-.2H32v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    d: "M33 24.9h.2v.1H33Zm.3.2.1-.1.2.1h-.3Zm0 .4v-.1h.1a.1.1 0 0 1 0 .2l-.2-.1Zm-.4-.2h.2v.2l-.2-.2Zm-.6.1a.1.1 0 0 1 .3-.1.1.1 0 1 1-.3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CBEBF",
    d: "M33.3 25h.2v.2l-.2-.1Zm0 .4h.2l-.1.1h-.1Zm-.4 0 .1-.2v.2h-.1Zm.2-.5h.1-.1Zm-.8.5.2-.2.1.1-.1.2-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M32.6 25.3h-.1v.1l.1-.1Zm.4-.1v.2-.2Zm.1 0-.1.2.1-.2Zm.1-.5v.1s-.1 0 0 0c0 .1 0 0 0 0Zm.3.3c-.1 0-.1 0 0 0Zm0 .3v.1h-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    d: "m34 25-.1.4c-.2 0-.6.4-1 .3-.5 0-1-.3-1-.3l.1.1.3.1.4.2h.4l.4-.2.3-.1.2-.2V25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M25.8 22.7v.2-.2Zm.7.7v.1h-.2.1v-.1Zm-1.6 0 .1.2.1-.1h-.2Zm.3.6h.1a.1.1 0 0 0 .2 0h-.3Zm.5.4h.1s.1-.1 0-.1l-.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CBEBF",
    d: "M26.5 24.1s0-.6-.4-1c-.5-.4-.7-.3-.9-.1-.2.1-.3.6.2 1 .5.5 1 .3 1 .3v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    fillRule: "evenodd",
    d: "m25.5 22.8.6.3a1.1 1.1 0 0 1 .4 1v.2a.8.8 0 0 1-.1 0H26c-.2 0-.5 0-.7-.2-.5-.5-.4-1-.2-1.1l.3-.2Zm1 1.5v-.5a1 1 0 0 0-.4-.7c-.2-.2-.4-.2-.6-.2l-.3.1c-.1.1-.3.6.2 1a1.3 1.3 0 0 0 1 .3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C8489",
    d: "M25 23.5s0-.3.2-.4c.2-.1.7-.2.9.3.2.4.3.7.2 1H26l-.4-.3-.3-.2-.2-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    d: "M26.4 24.2h-.2c-.2 0-1-.1-1.1-.8v.3l.2.2.2.2.3.2h.5l.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    d: "M26 24h.2v.1L26 24Zm0-.4h.2v.1H26Zm-.3.4h.2l-.1.1Zm0-.4h.2l-.1.2-.1-.2Zm-.3 0h.2l-.1.2-.1-.1Zm0-.3h.2l-.1.1v-.1Zm.4 0c0-.1 0 0 0 0h.2l-.2.1v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CBEBF",
    d: "M25.4 23.3h.2-.1s-.1 0 0 0Zm0 .4v-.1h.1v.1h-.2Zm.4-.4h.1-.1Zm-.1.3v.1h.2l-.1-.2-.1.1Zm.4 0h.2l-.1-.1H26Zm-.4.4h.2l-.1.1h-.1Zm.3 0h.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M26.1 23.4v.2-.2Zm-.3-.3v.2-.2Zm-.3 0v.2-.2Zm-.1.1s.1.1 0 .1v-.1Zm.2.3h.1c0 .1.1.1 0 .2v-.2Zm-.3 0h.1v.1h-.1Zm.8.3v.2-.2Zm-.1.1c.1 0 .1.1 0 .1v-.1Zm-.3 0v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    d: "M25.5 22.9s-.3 0-.3.2l-.1.4v-.4l.1-.1.1-.1h.2Zm1 1.1v-.3l-.4-.6.2.2v.2l.1.2v.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "m26.8 23.6.1.1v.1h-.1v-.2Zm-.5 1.2h.1c.1-.1.2-.1.2 0h-.3Zm.8.3h.1v-.2l-.1.2Zm-.1 0v-.2h.2l-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CBEBF",
    d: "M28.3 24.5s-.5-.7-1.2-.7a.7.7 0 0 0-.8.6c0 .2.3.5 1 .6.8 0 1-.4 1-.4v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    fillRule: "evenodd",
    d: "M27 23.8c.4 0 .7.2 1 .3a2.1 2.1 0 0 1 .3.4v.1l-.2.2-.8.2c-.7 0-1-.4-1-.6a.7.7 0 0 1 .8-.6Zm1.2.7a1.5 1.5 0 0 0 0-.1l-.3-.2c-.2-.2-.5-.4-.8-.4a.7.7 0 0 0-.8.6c0 .2.3.5 1 .6l.8-.2.1-.1v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C8489",
    d: "m27.7 24 .3.3v.2s-.4-.4-.8-.5c-.3 0-.6 0-.7.2l.1.5 1 .2h.3l.2-.1v-.3h.1l-.2-.2-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    d: "M27.1 24.1h-.2.2Zm-.4.2h.2s-.1.1-.2 0Zm.5.2h.2l-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CBEBF",
    d: "M26.8 24.6h.2l-.1.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    d: "M27.4 24.8h.2-.1Zm.3-.2h.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CBEBF",
    d: "M27 24v.1Zm-.1.3h-.2.2Zm0 .3Zm.4-.1h-.1v-.1l.1.1Zm.6.1h-.2l.1-.1v.1Zm-.3.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M27.6 24.6h.2-.2Zm-.3.2h.2-.2Zm-.2-.4h.1v.1l-.1-.1Zm-.1.1h.2-.2Zm-.3 0h.2v.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M26.7 24.7c.1-.1.2-.1.2 0h-.2Zm0-.5v.1Zm.2-.3.1.1v.1l-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    d: "M28.1 24.7s-.2.2-.7.2c-.5 0-1-.2-1-.5v.3l.4.2h1.3v-.1Zm.1-.2-.2-.2-.6-.4.4.1.2.2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "m28.2 24 .2.1v.1h-.1V24Zm.4-.2.2.1v.2l-.1-.1-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "m28.7 23.8.2.1v.1h-.1v-.2Zm.7.2v.2-.2Zm.1 0 .1.1v.1-.2Zm-1.1 1.4h.2c0-.1 0-.1-.1 0h-.1Zm.6.2h.2v-.2l-.2.2Zm.5 0h.2v-.2h-.1v.2Zm.2 0v-.1s.1-.1 0-.1v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CBEBF",
    d: "M28.1 24.8c0-.3.3-.8.7-.8l.7.2.4.2h.9l-.4.5-.2.1s0 .3-.4.4h-1.1c-.3-.1-.6-.3-.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    fillRule: "evenodd",
    d: "M28.2 24.6v.2l.1.3.4.2.5.1h.6a1 1 0 0 0 .4-.3l.2-.2.3-.5h-.8a.7.7 0 0 1-.2 0l-.2-.2a3.5 3.5 0 0 0-.7-.2c-.2 0-.3.2-.5.3l-.1.3Zm2-.2h.6l-.4.5-.1.2h-.1c-.1.2-.2.3-.4.3h-1.1a.9.9 0 0 1-.4-.2.5.5 0 0 1-.2-.4v-.3l.2-.2c.1-.2.3-.3.5-.3h.3l.4.2.3.1.1.1a.8.8 0 0 0 .3 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    d: "M28.1 24.8v-.2l.3-.4.4-.2h.3l.4.2.2.2h1l-.3.5-.2.1c0 .2-.2.3-.4.4h-1.1a.8.8 0 0 1-.4-.3.5.5 0 0 1-.2-.3c0 .1 0 .3.2.4l.4.2h1.1c.2 0 .4-.2.5-.3v-.2l.5-.5h-1l-.3-.2a2.7 2.7 0 0 0-.7-.2h-.3a1 1 0 0 0-.3.4l-.1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C8489",
    d: "M30.4 24.8h-.2s-1-.6-1.4-.5c-.3 0-.6.1-.6.5l.1.4.7.2h.7l.3-.2h.1l.2-.2v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    d: "M28.7 24.7h-.2l.1-.1h.1Zm.1-.3.1-.1h.2c0 .1 0 .2-.2.2v-.1Zm.7.1h.1v.1h-.1Zm0 .4h.2v.1h-.1Zm-.2.3V25h.2l-.1.2-.1-.1Zm-.6-.1.1-.1v.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CBEBF",
    d: "M28.7 24.7h-.2l.1-.1h.1Zm.3-.3h-.2l.1-.1h.1Zm.6.1v.1h-.1v-.2l.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    d: "M29.3 24.8H29l.1-.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CBEBF",
    d: "m28.9 25-.1.1h-.1l.1-.1Zm.4-.2h-.2.2Zm.5 0-.1.2-.1-.1h.2Zm-.3.3-.1.1h-.1V25h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M29.5 24.8h.2v.1h-.2Zm-.1-.5.1.1v.1l-.1-.2Zm-.4.3.2.1v.1H29v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M29 24.7h.2v.1H29v-.1Zm-.2-.5h.1c0 .1.1.2 0 .2l-.1-.2Zm-.4.3.2.1-.2-.1Zm0 .2h.2-.2Zm.8.5h.2-.2Zm-.6-.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    d: "m30.2 25-.3.3h-.7a1.4 1.4 0 0 1-1-.4l.2.3.2.1.3.1h1l.1-.1.1-.1.1-.2Zm-.2-.6h-.3c-.2-.2-.4-.3-.8-.3-.5 0-.6.3-.6.3l.2-.3h.8l.2.1h.2l.2.2Zm.5.2h-.4v-.1h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C8489",
    d: "M30 26.3h.8l.1-.4h.1l.3-.3h.5l.2-.1.2-.1v-.1l.2-.2-.1-.2-.2-.3-.3-.1H31l-.5.2s-.3.1-.4.4l-.1.5v.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    fillRule: "evenodd",
    d: "M31.4 24.5h.6l.2.3v.5l-.3.2h-.4l-.2.2-.3.1-.1.1-.1.3-.1.2H30v-.1a4.2 4.2 0 0 1 0-.7v-.3a.9.9 0 0 1 .3-.5 1.2 1.2 0 0 1 .2-.1l.5-.1.3-.1Zm-.8.2a.8.8 0 0 0-.1.1l-.3.3v.2l-.1.2v.1a5.8 5.8 0 0 0 0 .6v.1h.6l.1-.4.1-.1.3-.2h.5l.2-.2h.2v-.2l.1-.1v-.2l-.2-.3-.3-.1h-.3l-.3.1-.5.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CBEBF",
    d: "m30.2 26.2.1-.4.3-.4h.2l.1-.3.3-.2v.1h.2v-.1h.3v.2h.2V25s.2.1.2 0l-.1-.3h-.7l-.4.2-.3.1v.3c-.2 0-.2-.2-.3-.2v.4l-.2.5.1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CBEBF",
    d: "M30.5 25.7v.2h.2v-.1h-.2Zm.6-.4v.1h.1v-.1Zm.5 0c-.1 0-.2 0-.1.1 0 .1 0 .1 0 0h.1Zm-1.4.2h.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    d: "M30.7 25.8v.1h-.2.2Zm1.2-.8v.1h-.1l-.1-.1.1.1h.1Zm-1 .3-.2.1h.1Zm.1 0v.1h.2-.1v-.1Zm.4-.4v.1h-.1l.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04534E",
    d: "m30.2 26.4.5-.1s0-.4.2-.6c.3-.2.6-.2.7-.2.2 0 .5-.1.6-.4 0-.2-.2-.2-.3-.4-.1-.2-.3 0-.4 0h-.4v.2h-.5v.3-.4l.4-.2.4-.3h.4l.3.2.1.2v.4c0 .3-.3.5-.6.5-.2 0-.4 0-.6.2l-.2.6h-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M30.4 25.4h-.1v-.2.1Zm.3 0v-.2l.1-.1v.1l-.1.1Zm-.1.4v-.2.2Zm.2-.1h-.1l-.1.1.2-.1Zm.4-.6v.1c-.1 0-.1.1 0 .1V25Zm.2.2H31h.2Zm-.1-.4.1-.2-.1.2Zm.6 0-.1.1.1-.1Zm-.2.4v.1h-.2.1l.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M27.5 24.3c.1 0 .3-.2.3-.4s0-.4-.2-.4-.3.1-.3.3c0 .3 0 .5.2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "m27.7 23.2-.2.4h.2v-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M27.7 23.1v.4h-.2l.2-.4Zm0 0-.1.4.1-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M27.8 23h-.2l.1.2h.2l-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M27.6 23h.2v.2l-.2-.1Zm0 0 .1.2h.1V23h-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "m34.7 24-.4.4h.1l.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "m34.7 24-.3.4h-.2l.5-.4Zm-.4.3h.1l.3-.3-.4.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M34.8 23.8a.1.1 0 0 0-.1 0v.3l.2-.1v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M34.7 23.8h.1c.1 0 .1.1 0 .2 0 0 0 .1-.1 0v-.2Zm.1 0a.1.1 0 0 0-.1 0v.2h.2v-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "m24.6 21.8.2.5.1-.1-.2-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "m24.7 21.8.3.4-.2.1-.2-.5h.1Zm0 0 .1.5.1-.1-.2-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3E",
    d: "M24.6 21.6c-.1 0-.1.2 0 .2h.1v-.1a.1.1 0 0 0-.1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    fillRule: "evenodd",
    d: "M24.5 21.6a.1.1 0 0 1 .2 0v.2c0 .1-.1 0-.2 0v-.2Zm0 0v.2h.2v-.1a.1.1 0 0 0-.1 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8C30",
    d: "M27.8 23h-.1v.2c.1 0 0 0 0 0V23h.1Zm-.1.3h-.1v-.1h.1Zm7.2.6h-.2v.2-.2h.1Zm-.3.2-.2.1.2-.2v.1Zm-10-2.5v.2h.1-.1v-.1Zm.1.4v.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M24.8 22.8c.2.2.4.4.5.3.1 0 .2-.3 0-.5 0-.2-.2-.4-.4-.3-.1 0-.2.3 0 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E92736",
    d: "M24.6 22.6h.2v-.2l-.1-.1-.2.1v.1l.1.1Zm.2-.3v.1h.2V22h-.3v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E92736",
    d: "M25.2 22.3V22c0-.1-.3 0-.2 0v.2h.2Zm2.1 1.2h.2v-.2h-.2v.2Zm.2-.1v.2h.2c0-.1.1-.2 0-.2h.1l-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E92736",
    d: "M27.9 23.7v-.2c.1 0 0-.2 0-.1h-.1v.3Zm6.2.5v.1h.2V24h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E92736",
    d: "M34.3 24.2v.2h.2v-.2c-.1 0 0 0 0 0h-.2Zm.1.4h.1v-.2h-.1v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E204",
    d: "M24.8 22.4v.1h-.2l.1-.1Zm0-.1h.1v-.1h-.1Zm.2-.1h.1Zm2.5 1.2v.1h-.1v-.1h.1Zm.1 0v.1h.1v-.1h-.1Zm.2 0v.2h.1v-.1Zm6.5.9h-.1v-.1Zm0 0h.1Zm.1.1v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M33.7 25c.1 0 .3 0 .5-.2.1-.1.2-.3.1-.4l-.4.1-.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8AC71",
    d: "M26.8 18.7h-.6c-.3 0-.2-.7-.2-.7s-.2-.2-.1-.3c0-.2.4-.6.5-.6h.3l-.1.2v.2l-.2.3h.3l.2-.1s0 .2-.2.2l-.3.1s0 .2.2.2h.3l-.1.5Zm-1.4 1.5s.2 0 .2.3l-.2.7c0 .4 0 .4.5.8l.2.2c0 .2 0 .9.6.9.4 0 .5-.3.5-.3l-.2-.3h-.3a.3.3 0 0 1-.2-.2l-.1-.5c-.2-.3-.6-.4-.6-.7 0-.3.2-.3.2-.7 0-.4-.5-.5-.5-.5l-.2-.1v.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1A720",
    d: "M26.7 17.6V17v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8AC71",
    d: "M27 21.7h-.1c0-.1-.3-.3-.3-.9 0-.7 1-1 1.1-1.3.1-.3.3-.4-.5-1l-.2.2.4.2v.3l-.6.4-.3.3-.2.4v.6s0 .7.7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78732E",
    d: "M26.5 22v.3h-.1l-.1.1-.1.1-.1-.2h.2l.2-.2Zm-.4.1H26l-.1-.2h.2v.2Zm.2-.4.1.1v.1h-.2l.1-.2h.1Zm0 1.1h-.1v-.2h.2v.1l-.1.1Zm.4-.3-.1-.1-.1.2h.1l.1-.1Zm-.4.4h.1l.1.1.1-.2h-.2l-.1.1Zm.4-.1.2-.2v-.1h-.1v.1l-.1.2Zm-.2.2h.5l.1-.1h-.2l-.4.1Zm-.2-1.9V21l.1.1-.1.1Zm.2.4-.1-.1v-.1h.1v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C7A6",
    d: "M26 17.5c0 .1-.1.2 0 .2l.4-.2v-.2l.1-.2h-.2l-.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C242F",
    d: "M26.5 17.3v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8AC71",
    d: "m26.2 17.3-.1.1.2-.1.3-.1h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78732E",
    d: "M26.6 21v-.2.1l-.1.1h.1Zm-.4-.2v-.5l.1.1.2.3h-.1l-.1.1Zm.4 0v-.1l.1-.2-.2.2h.1m-.3-.5V20l.2-.2v.2l.1.2h-.2l-.1-.1Zm.8.8.2-.2-.3.1v.1Zm-.2-.6.1-.1h.1v.3-.1l-.2-.1Zm.1-.1.1-.2-.3-.1v.2h.1Zm0-.5v-.3l-.2.1v.1h.2Zm.3-.3v-.3.1l-.2.1h.2Zm.1.3.2-.1.1-.2h-.4v.2l.1.1Zm-.9-1.3v.2h.3v-.1h-.1l-.1-.2v.1Zm.7 1.5h.1l.1-.2h-.3v.2Zm.5-.5V19l-.2.1v.1l.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78732E",
    d: "M27.4 19.2v-.1h.3l-.2.1h-.1Zm.3-.2v-.2h-.2v.2h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.5 20.8v.1h.2l-.1-.1h-.2Zm0-.5.2-.1h.2l-.1-.1h-.2v.2Zm.4.4-.1-.1h-.2.2l.1.2v-.1Zm-.4-.5v-.1l.2-.1h-.2v.2Zm0-.2v-.1h-.1v.3-.2Zm.7-1.8h.1v.3l-.2.2h.1v-.2l.2.2h.1v-.2l.3.1-.2-.2.2-.1h-.5v-.1H26v.2l.2-.2Zm.1.2.2-.1v.3l-.2-.2Zm-.7 2h.4l-.2-.1h-.2Zm2-1v-.2l.2-.1h-.2l-.2-.1v-.2h.1v-.1H27h.4v.3h.2l-.1.2-.2-.1.1.1h-.1v.3H27v.3c-.1 0-.2 0-.3-.2v.4l-.2-.2v.5l-.3-.1v.1l.1.4-.2.1.2.2-.1.1h.4-.1l.1-.3v-.1l.1-.2v-.1l.2-.1V20h.2v-.2h.3v-.3h.3l-.1-.2Zm-1 1.4-.1.2-.2-.1.2-.2h.1Zm0-.3-.1.2-.2-.4h.3v.2Zm.3-.2h-.3v-.4l.2.1v.3Zm0-.3v-.3l.2.1v.2h-.3Zm.5-.2H27v-.3h.2v.3Zm0-.3v-.3h.1v.2h.2-.3Zm-.7 1.7-.2.1h-.2.2v.2-.2h.2v.3h.1-.2v-.2h.1v-.1h-.1Zm-1.1-.1h.2l-.2-.1-.2.1v.1l.2-.1Zm1.2 1.8h-.2l.4-.3-.3.2v-.3l-.2.1v-.3h-.1v-.2.2H26l.2.1-.2.1v.1h.3c0 .2-.2.2-.2.2v.1h.4v.1h.3l.1-.2-.2.1Zm-.6-.4h.1l.2-.1v.2h-.3Zm.1.3.2-.1.2-.2v.3h-.4Zm-.1-.9h.3-.3l.1-.2-.2.1-.2.1h.2v.2-.2Zm-.3-.6h-.3l-.2.1v.1l.2-.2h.3Zm.3.3-.1-.1-.2.1-.1.2v.1l.1-.2.3-.1Zm-.4 0 .2-.2h-.3l-.2.2.1.1.2-.2Zm.5-4.3h.2v.1l-.2.2v.4-.4c.1 0 .2 0 .2-.2v-.2l-.3.1-.1.1h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78732E",
    d: "M26.7 18.2h-.2v.2l.2-.2Zm-.2 0h-.2v.2l.2-.2Zm0 .5-.2-.3-.1.2h.2Zm.6 4.2-.4.1h-.3l-.2-.2v-.4l-.2-.3c0-.2-.2-.2-.3-.4a.7.7 0 0 1-.3-.5v-.4l.2-.4-.1-.2h-.2.2v.5l-.1.5a.7.7 0 0 0 .2.6c.2 0 .3.2.4.3l.1.4v.3l.2.2h.8v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78732E",
    d: "M27 22.4h-.4v-.2l-.2-.3c0-.2-.2-.3-.3-.4l-.3-.3.1-.4.1-.4c0-.2-.2-.3-.3-.4l-.3-.2.3.2.3.4-.1.4-.1.3v.1l.3.3.3.4.1.3.1.2h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8AC71",
    d: "m27.8 21.7.1.2v.3l-.3-.2.2-.1v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M25 20.1h-.2V20l-.1-.2h.1l.1-.2.2.1-.1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M24.8 19.8h-.1v.1a.2.2 0 0 0 0 .2h.1a.4.4 0 0 0 .2 0v-.4h-.1Zm.2 0v.3a.4.4 0 0 1-.2 0 .2.2 0 0 1 0-.1h-.1v-.2h.1a.8.8 0 0 0 0-.1h.2Zm-.2 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M25.2 20.2H25V20l-.1-.1.1-.1.1-.1h.1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M25 19.8h-.1v.4h.2l.1-.3v-.1H25v.1Zm.2 0v-.1H25l-.1.1v.4h.1a.3.3 0 0 0 .2 0v-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M25.4 20.2h-.2v-.1l-.1-.2h.1s0-.2.2-.2v.3c-.1 0 0 .2 0 .2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M25.2 19.8v.1H25v.2l.1.1h.1v-.4h.1v-.1h-.1Zm.3 0a.4.4 0 0 0 0 .1l-.2.1v.1a.3.3 0 0 0 .1 0v.1h-.2a.6.6 0 0 1 0-.1l-.1-.2h.1v-.1h.1v-.1a.2.2 0 0 1 .2.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF7029",
    d: "m27.5 21.7-.2-.3-.2-.2-.2-.1-.1-.3v-.4s-.3 0-.1 1c0 .3.3.3.3.3h.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#816C2A",
    d: "M27.3 19h.1c-.1.4-.4.5-.7.7l-.4.4-.1.6c0 .5.2.7.4.9l.5.1h.7v.2h-.2.2v-.1l-.1-.1H27l-.5-.1c-.2-.2-.4-.4-.4-.9 0-.3 0-.5.2-.6l.5-.5c.3-.1.4-.3.6-.6l-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28 21.8-.2.2h.1v.1h-.2V22h.1v-.3l.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3D",
    d: "M28.3 22H28v-.2l-.2-.1h-.2l-.5-.5h1v.1l.1.1.1.2v.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF7029",
    d: "M28.3 22H28v.4h.2l.1-.3V22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3D",
    d: "M28.3 21.8v.1-.1ZM28 19v-.4h-.2v-.2h-.1v-.1h-.3l-.2.2s.4.2.5.5l.3.2V19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF7029",
    d: "m27.8 19.2-.1.4.2-.2v-.2c0-.1 0-.2-.2-.2v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#816C2A",
    d: "m28.2 22.3-.2-.1-.1-.1h.1l.1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F5B24",
    d: "m28.3 22-.1.2-.2.2h.4V22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404118",
    d: "M28.4 22.3h-.1v.1-.3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78732E",
    fillRule: "evenodd",
    d: "M26.5 17.2h-.1a2 2 0 0 0-.3.2 2.2 2.2 0 0 0-.2.2v.3h.1v.7l.2.2h.4a4.2 4.2 0 0 0 .2 0l.1-.5h-.5a.2.2 0 0 1 0-.2h.3a.5.5 0 0 0 .2-.3l-.2.1a.9.9 0 0 1-.3.1v-.5h.1v-.2l.1-.1v-.1h.1V17a.5.5 0 0 0-.1 0Zm-.1.8a.2.2 0 0 0 0 .1v.1h.2a1.3 1.3 0 0 0 .3 0l-.1.5a5.2 5.2 0 0 1-.6 0l-.2-.1V18a1.2 1.2 0 0 0 0-.1v-.1l-.2-.2v-.1h.1a2.2 2.2 0 0 1 .5-.5.4.4 0 0 1 .1 0 1.3 1.3 0 0 1 .2 0 1.8 1.8 0 0 0 0 .2h-.1v.2h-.1v.1l-.1.2h.5v-.1l-.2.2h-.1v.1h-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "M29.9 16s-.7-.1-.7.4c0 .2 0 .3.2.3.1 0 .4 0 .7.3l.2.4v.3l.1.7.2.5.4-.2.3-.8-.4-1.4-1-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    fillRule: "evenodd",
    d: "m29.9 16 1 .5.4 1.4-.3.8-.5.3-.1-.6-.2-.7a.6.6 0 0 0 .1-.3v-.2L30 17l-.6-.3h-.2l-.1-.3.1-.3.2-.1a.9.9 0 0 1 .4 0Zm.4 1.7.1.7.2.5.4-.2.2-.8-.3-1.4-1-.5a1 1 0 0 0-.3 0l-.3.1v.5h.1l.7.3.2.3a.5.5 0 0 1 0 .5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "M30.5 18.8s.3-.1.3-.3l-.2-.3.2.1s0 .1 0 0l.2-.2-.2-.3h-.2.3v-.3l-.2-.1h-.2s.1-.1.2 0h.2l-.1-.3-.2-.2h-.2.2-.1l-.4-.3h-.3.2l-.3-.1h-.5.1l.1-.1c.1 0 0-.1 0-.1V16h.4l.8.5.4.3.2.6v1l-.6.4h-.2v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2A567",
    d: "M29.9 16.2V16l-.5.1c-.2.2 0 .4 0 .4l.1-.1h.3l-.1-.1h-.2l.2-.1h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "M30.6 18.8h-.1v.8l.7 1.1h.4l.1-.2.4.3.2.1.5.6v-.2l-.1-.3-.2-.2h.3l.2.1v.1l.1.2.1.2v.2l.2.2v-.3l-.2-.6v-.2.2l.3.2v.2l.1.2v.1l.1.2h.1v-.2l-.1-.4v-.4l.2.3v.7l.2.4.1.2.1.1v-.2l-.1-1.5.1.2v.3l.1.1v.7l.2.3.1.2v-1.8h.1l.1.1v.4l.1 1v.3l.3-2.7h.2v-.2l-.4-.4-.2-.5-.3-.7-.7-.7-.4-.4-.2-.1v-.1l.1-.2h-.5l-.4-.3-.4-.2-.3-.1-.6-.2H30l-.1.1v.3s0 .2.2.2.6.4.6.4l.2.2v.1l.2 1-.3.6-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "M31.3 20.5h.3c.1-.1-.1-.6-.1-.6l.2.2v.3c0 .2-.2.3-.2.3h-.2v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "m35.2 22.9-.2-.4V21l-.2-.2v-.5l-.4-.8.1.1.2.2.4.1h.2l.1.3.1.7-.1.7-.1 1v.3h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "m35.2 21.7.1-.3v-1.2a1 1 0 0 0-.5-.3l.1.4.1.1v.2l.2.5v.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "M34.6 22.3V21a3 3 0 0 1-.3-.6l-.2-.6s-.1-.2-.2-.1h-.1v-.4l.1.2.4.3.2.8.2.5v1.6-.4Zm.2-2.3.2.1.2.1H35l-.1-.1V20Zm-.7 2.1V21c-.1 0-.3-.1-.4-.4l-.2-.5-.2-.2v-.3l.3.1.2.1.2.8.1.3v.3l.2.8v.6l-.2-.4Zm-.4-.3v-.5l-.2-.4-.4-.5-.4-.5v-.3l.2.2h.2l.1.4.1.3.2.2.1.1v.4l.1.2.1.3v.2l-.1-.1Zm-.3 0v-.3l-.2-.3v-.3a11.4 11.4 0 0 0-.8-.6l-.2-.1v-.4s0 .2.2.2h.2l.2.5.1.2.3.2v.2l.1.2.1.3v.2Zm-.5-.1-.2-.3V21l-.4-.4-.3-.3v-.1h.1l.5.5.1.2v.3l.2.1v.2Zm1.5-2.2s.3.4.4 0l-.1-.4-.4-.6-.5-.7-.3-.1v.2s.3.2.6.8c.3.5.3.8.3.8Zm-1.7-2.2 1 1c.4.6.5 1 .4 1 0 0-.3 0-.4-.2l-.5-.8-.5-.4-.3-.4.3-.2Zm-.3 1.2a10.3 10.3 0 0 0 1 1v-.1c0-.1.1 0 .1 0l-1-1.2v.3Zm0 0s0 .3.3.4c0 .2.2.3.3.4l.1.3-.5-.3.1.3-.1-.1-.2-.3-.1-.3-.2-.3h.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "M30.9 19.7s.2.2.4 0v-.5s.4.6.5 0l-.2-.4.2.3s.2-.1.2-.3l-.2-.5.2.2s.3 0 .3-.2l-.2-.4s.2 0 .2-.2l-.3-.3s0-.2.2-.1c.1 0 .3.1.4 0V17h-.2l-.3-.2-.3-.1h-.2v.1l.1.6v1.3h-.1v.1l-.2.3-.1.2-.2.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "m32.7 20.7-.2-.3a.7.7 0 0 0-.4 0l.4.3h.2Zm.5.1-.2-.4-.3-.3v.3l.2.2.3.2Zm.5 0-.2-.6-.3-.4v.3l.1.3.2.3h.2Zm.3-.2V20c0-.2-.2-.2-.2-.2h-.1v.5l.2.3.1.1Zm.4-1 .1.3.3.8-.4-.5-.1-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2A567",
    d: "M32 20.3h.1l-.2-.4h.2s-.2-.3-.1-.4l.2.3v.3c0 .3-.3.2-.3.2Zm.3-.4h.3l-.2-.3c0-.1.1 0 .1 0l-.2-.4h.1s.2.1.2.3l.2.4c0 .3-.5 0-.5 0Zm1.3-.4v-.2h.1l-.2-.2h-.1l.1.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2A567",
    d: "m32.8 19.6.4.1-.3-.4h.2v.1l.2.2v-.3l.1.2s.3.2.4.1v-.2.3h-.4v-.2.3H33l-.2-.2Zm1-.3.5.3-.1-.8s.3.7.2.8c-.2.1-.2 0-.2 0H34l-.2-.3Zm1.3 1.2h.1l-.1.1v-.1Zm-.5-1.5h.1-.1Zm-.1-.3h.1l-.1-.1h-.1v.1Zm.4 1.4h.2v.1H35l-.1-.1ZM34 18h.1v.1L34 18h.1Zm-.6-.6h.2s.1.3 0 .4l-.3-.2-.1-.2h.2Zm-.3-.1s.2 0 .2-.2a.3.3 0 0 0-.2-.2l-.2.2.2.1Zm-.7-.3h.2l.3-.3h.2v.2l-.4.2h-.2V17Zm0-.4c0-.2-.2-.2-.2-.2l.1.3v.3h.1v-.4Zm-.6-.2-.5-.4.5.4.1.4h.1v-.2l-.1-.1v-.1Zm-.5-.2c-.2-.2-.6-.3-1-.3-.2 0-.4 0-.4.2 0 .1.2.2.5.2h.5l.3.2-.2-.2-.3-.2h.2c.2 0 .4.1.5.3v.3h.1v-.4l-.2-.1Zm-.9 2.6c.2 0 .5-.2.5-.6a3 3 0 0 0-.2-1.2h.1l.3 1c0 .4-.1.5-.3.8l-.4.1ZM31 20s0 .1.1 0c.2 0 .4 0 .4-.3l-.2-.3h.2v.2h.1c.1 0 .3-.1.2-.3l-.2-.3v-.1h.2v.2h.2s.2-.1.1-.2l-.1-.2v-.1h.2l.2-.2v-.2h.1v.3l-.1.2h-.2v.5H32v.2l-.1.2-.2.1h-.1v.1l-.1.2-.3.2h-.1L31 20Zm1.2-2s.4 0 .3-.2l-.3-.5h.4c.1-.1 0-.2 0-.2h.2v.2l-.1.5s0 .2-.2.2h-.3Zm.3 2.7v-.2l-.3-.1.3.3Zm.6 0-.3-.3s0-.2-.2-.2l.1.2.3.3Zm.5 0-.2-.4-.2-.4c-.1 0 0 .2 0 .2v.3l.2.2.2.1Zm.3-.2v-.4c0-.2-.2-.3-.2-.3v.3l.2.4Zm.8.2-.2-.4-.2-.4v.2l.2.5h.2Zm.7-.8-.4-.2-.5-.1.1.1.3.1.3.1h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M32.6 20s0 .3.2.4l.4.4.2.6.1.5s.1.1 0 .1l-.1-.2-.2-.8-.6-.6-.2-.2h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M33.2 21.5v-.4l-.5-.4h-.2l-.4-.4.4.5c.2.1.2.3.3.5v.3l.2.1-.2-.4-.2-.5c.2 0 .5.2.5.3l.1.4.2.4-.1-.4Zm-.4-1.9.3.2.3.7.3.3.1.7.1.8-.2-.4-.2-.6-.2-.4s.2.1.3.4l.1.4v-.4l-.1-.5-.3-.3a2 2 0 0 1-.2-.5h-.2l-.1-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m33.3 19.5.3.2h.1s0 .4.2.7l.3.4v.6l.1.8v1-.7c-.1-.2-.2-.2-.3-.7-.1-.5 0-.6-.2-.8l-.1-.2.2.2v.7l.4.7-.1-.9-.1-.7-.3-.4-.1-.6h-.1l-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M33.8 19.3s0 .2.3.3h.2s0 .4.2.7l.2.4v2.7-1l-.2-.2c0-.2 0-.8-.2-1.1l-.1-.3.2.3.1 1 .2.4V21s-.4-.6-.4-.9v-.3s-.2 0-.3-.2l-.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M34.4 19.5s.1.2.4.3h.5l.2 1-.1 1-.2 1.5v.2l-.1.2-.1-.2V21l-.3-.3.3.3v1.4-.2l.2-1-.3-1 .1.3h.2-.1v2.3c.2 0 .2-.6.2-1l.2-1-.2-.8-.6-.2-.3-.3Zm-3.3.5h.1l.4-.3v-.1l.3-.2V19h.1l.2-.3v-.2l.3-.3s0-.2-.2-.3h.2l.1-.2-.2-.4h.3v-.2h.2l.4-.2-.3.2.3.2h.3l-.2.1.5.5h.2-.1c0 .2.2.4.3.5v.1h.2-.1l.3.6-.7-.9-.4-.4.4.6.3.6s-.4-.8-.9-1.2l-.6-.5v.4l.7.7.7 1-.8-1-.7-.6v.2l-.2.1.4.4.2.1h.2-.3l.4.5h.1l.2.1h-.3l.2.3-.6-.7-.5-.3h-.1l-.1.2.4.5.4.4-.4-.4-.4-.3v.2l.4.5-.5-.6v.1H32l.6.8-.5-.4.2.4-.4-.4-.3.2.5.5-.5-.4.1.4-.2-.3v.1h-.2l.1.2v.3-.3l-.2-.1H31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M35.3 19.9h.2l-.2-.2-.8-1.6c-.6-.9-1.2-1.2-1.2-1.2s.7.4 1.2 1.1l.8 1.6.3.2-.1.1h-.2Zm-4.5-.2.3-.3h-.2v-.2.1h.2l.3-.3h-.2v-.2.1h.3s.2-.2.1-.3h-.1l-.1-.3.1.2.2-.1V18h-.2l-.2-.2.2.1h.2v-.4l-.1-.2h-.4.2a.2.2 0 0 0 .2-.2l-.1-.2v-.1H31h.2v-.1l-.1-.3-.4-.3.7.5h.1v-.2l-.2-.2s.2 0 .2.2v.3h.5v-.2l-.2-.1.2.1v.3l.2.1.2.1v-.4.4h.2s0 .1-.2 0l-.8-.2.4.3c.2.1.2.3.2.3l-.2-.2-.4-.1h.1v.2s.4.3.3.4h-.3.1v.2l.2.3s-.2.1-.1.2l.1.2-.2-.2s0-.1 0 0l-.2.2.2.2v.2l-.3-.2-.1.3.1.2v.2l-.3-.3-.2.3.1.1H31l-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M33.3 16.9v-.1l.1-.2h-.3l-.4-.2s-.9-.6-2.2-.7c-.4 0-.6.1-.6.2 0 0 0-.2.5-.1.2 0 1.5 0 2.2.6 0 0 .3.3.5.2h.3l-.1.2Zm-2.4.2s0-.2-.2-.3l-.8-.4.8.4.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2A567",
    d: "m31 18-.2-.1-.3-.1h.3l.1.2Zm-.1-.5h-.2l-.2-.1s.1-.1.2 0a.3.3 0 0 1 .2.1Zm-.1-.4-.2-.1h-.3.3l.2.1Zm-.2-.3h-.3l-.4-.2h.5l.2.2Zm-.5-.2-.3-.1h-.5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "m28.5 22.4.3.1c.2 0 .3.2.3.2l-.2.2h-.4l-.2-.2.2-.3Zm0-.2s0-.3-.2-.4v.3s.1.2 0 .2l.3-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "m28.3 21.8.1.1a.9.9 0 0 1 .2.3 4.7 4.7 0 0 1-.3.1.4.4 0 0 0 0-.2v-.2Zm0 .3a.5.5 0 0 1 0 .1v.1a1.4 1.4 0 0 0 .2-.1.9.9 0 0 0-.1-.3h-.1v.1a.3.3 0 0 0 0 .1Zm0 0Zm0 .6.2.2h.4l.2-.2a.6.6 0 0 0-.1 0l-.2-.2h-.2v-.1l-.3.3Zm.2-.3-.2.3.2.3h.4l.2-.3-.3-.2h-.2a.4.4 0 0 1 0-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M28.5 22.6h.2m-.3 0 .2-.4-.3.1.1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M28.6 22.2v.2a1.3 1.3 0 0 1-.2.1 2.3 2.3 0 0 1 0-.2l.1-.1Zm-.2.3a2.2 2.2 0 0 0 .1 0v-.2h.1v-.1l-.3.1a.8.8 0 0 0 .1.2Zm.2.2h.1v-.1h-.2.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M28.2 22.6s0 .2.2.2l.1-.2v-.1h-.3v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M28.4 22.5a.3.3 0 0 1 .1.1v.1h-.3v-.2a.5.5 0 0 1 .2 0Zm-.1 0v.2a.2.2 0 0 0 .2 0v-.2h-.1a.5.5 0 0 0-.1 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M28.4 22.5h-.2s-.1 0 0 0l.1-.2h.1v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M28.3 22.4H28v.1a.3.3 0 0 0 .1 0 .6.6 0 0 0 .2 0v-.1Zm.2 0v.1h-.2v.1h-.1l-.1-.1.2-.1h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M28.3 22.6s-.2.3-.4.3v-.5h.2l.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M28 22.4h.1l.1.1h.1v.1a2.9 2.9 0 0 1-.2.3h-.2v-.3a2.4 2.4 0 0 1 0-.2Zm0 0a2.1 2.1 0 0 0 0 .4h.1a2.1 2.1 0 0 0 .2-.2l-.2-.1H28Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M27.9 22.4h.3l-.3.2v-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M27.9 22.3Zm.3.1v.1h-.3a.7.7 0 0 1 0-.1 2.3 2.3 0 0 1 .3 0Zm-.3 0v.1h.2a1 1 0 0 0-.2-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202220",
    d: "M27 22.8s.1.2.3.2l.2-.2h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B4139",
    d: "m27 22.8.1.1h.4l-.3-.2-.1.1h.4l-.2.2a.2.2 0 0 1-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202220",
    d: "M27.2 22.8h.5l-.3-.3-.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B4139",
    d: "m27.2 22.8.2.1.3-.1-.2-.3-.3.3.3-.3.2.3h-.5Zm0 0h.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202220",
    d: "M27.4 22.6s0 .2.3.2h.1l-.2-.4-.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B4139",
    d: "M27.4 22.6v.1l.2.1h.2l-.2-.4-.2.3.2-.2.2.2-.2.1a.2.2 0 0 1-.1 0v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B4139",
    d: "m27.4 22.7.2.1h.2-.4v-.1Zm-.3.2h.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "m27.8 22.3.3.3c0 .2 0 .3-.2.3l-.2-.2c0-.1-.1-.2 0-.2l.1-.2Zm-.7 0h-.2v.3l.2-.1v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M27 22.4h-.1a.4.4 0 0 0 0 .1h.1v-.1Zm.1 0v.1a.6.6 0 0 1-.1 0h-.1a.4.4 0 0 1 0-.1v-.1h.1a.5.5 0 0 1 .1 0v.2Zm.7 0a2.8 2.8 0 0 0-.2 0v.2l.2.2.1.1h.1v-.3a.6.6 0 0 0 0-.2h-.2Zm.1 0a3.8 3.8 0 0 0-.3 0v.2l.2.2h.2v-.2a.5.5 0 0 0-.1-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M27 22.5v.2h.2l-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "m27 22.5.2.2a2.6 2.6 0 0 0-.2 0l-.1-.1v-.1h.1Zm.2.2-.1-.2a.5.5 0 0 0-.1 0v.2a.8.8 0 0 0 .1 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "m27.1 22.6-.1.1v.2l.2-.1v-.2Zm.1-.5c-.2 0-.2.1-.2.2v.2h.3V22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "m27.2 22.1.1.3-.3.1v-.2a.2.2 0 0 1 .1-.2h.1Zm-.2.4h.3l-.1-.4H27v.2a.5.5 0 0 0 0 .2Zm.1 0v.1a.7.7 0 0 1 .1.1 3.8 3.8 0 0 0 0 .2H27v-.2a.7.7 0 0 1 .1-.1Zm0 .1-.1.1a.3.3 0 0 0 0 .1h.2v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M27.2 22.3s-.2 0-.2.2l.1.2.3-.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "m27.2 22.3.2.2a1.6 1.6 0 0 1-.3.2v-.1l-.1-.1v-.1h.1a.8.8 0 0 1 .1-.1Zm0 0a.8.8 0 0 0-.1.1v.2a.8.8 0 0 0 .2 0v-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "m27.4 22.7-.2.1-.1-.2.2-.1.1.2Zm.2-.8h-.2l-.2.2v.3l.3-.2.1-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M27.6 21.9v.3a2.5 2.5 0 0 1-.3.2h-.1v-.5h.2a.3.3 0 0 1 .2 0Zm0 .3v-.3h-.3l-.1.2a.4.4 0 0 0 0 .2h.2v-.1h.1Zm-.3.3h-.1v.1c-.1 0 0 0 0 .1a1.8 1.8 0 0 0 .2 0 .7.7 0 0 0 0-.2Zm.1.2a.8.8 0 0 0 0-.2h-.2l-.1.1v.2h.1a1.9 1.9 0 0 0 .2-.1Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "m27.4 22.5-.2-.2.3-.2v.3l-.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M27.2 22.3v.1l.2.1a.7.7 0 0 0 .1-.2v-.1h-.3v.1Zm.4 0a.8.8 0 0 1-.1.2h-.4v-.2a.5.5 0 0 1 .2-.2h.1v.1a.6.6 0 0 1 0 .2Zm0 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "m27.6 22.5-.1.2-.2-.1v-.2h.2l.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "m27.5 22.4.1.1-.1.2h-.1l-.1-.1v-.1l.2-.1Zm0 0h-.1v.1h-.1v.2h.2v-.1h.1v-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M27.5 22.2s-.1.1 0 .2l.1.1h.2l.1-.2V22l-.4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "m27.8 22 .1.2v.2l-.2.1h-.2v-.2l.2-.2h.1Zm-.3.2v.4h.3v-.1l.1-.1v-.1h-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202220",
    d: "M27.8 21.8h-.2l-.1.3v.2l.2-.1v-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B4139",
    d: "M27.8 21.8h-.2l-.1.2v.1-.1l.1-.2h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M30.8 24h.4v.1l-.2.1V24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M31.2 23.9v.2l-.2.2-.1-.1V24h.2l.2-.2Zm-.4.2.1.1h.3v-.3l-.2.1-.2.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M30.6 24.1h.2v.1l-.1.2-.1-.1V24Zm1.1 0v-.2l-.3-.1v.4h.3v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "m31.4 23.7.3.2a.5.5 0 0 1 0 .1v.2h-.3v-.5Zm.3.3-.2-.2v.4h.2v-.1Zm-.9.1h-.2v.2h.2v-.1a.7.7 0 0 0 0-.1Zm0 .1a1.2 1.2 0 0 0 0-.1h-.3v.2h.4v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M30.6 24.1h-.1l-.2.1v.3h.2l.6-.3H31l-.2.1-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M30.6 24.1v.1h.5a15.3 15.3 0 0 1-.6.3h-.2v-.3l.2-.1a.1.1 0 0 1 .1 0Zm.5.1a.2.2 0 0 1-.2 0l-.2.1h-.1V24h-.2l-.1.1a.7.7 0 0 0 0 .2l.2.1h.2a7.6 7.6 0 0 0 .4-.3Zm-.5 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M31 24.3h-.4v.2h.3v-.2Zm1-.1-.2-.1h-.2v.2h.4v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M31.7 24h.1l.1.1v.2h-.2V24Zm.2.2V24a.2.2 0 0 0-.2 0v.2h.2v-.1Zm-1 0 .2.1v.2h-.4v-.1h.1l.1-.1Zm0 0v.1h-.2v.2h.3v-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "m31.2 24-.2.2v.2h.1l.3-.2v-.1h-.2Zm.9.3-.2-.1-.1.1v.1h.4v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M31.2 24h.2v.3l-.3.1H31a2 2 0 0 1 0-.1v-.1a.5.5 0 0 1 .2-.1Zm0 .1H31v.2h.4V24h-.2Zm.7 0 .1.1.1.2h-.4v-.1a.6.6 0 0 1 0-.1Zm-.1.2v.1h.4v-.1a.2.2 0 0 0-.2-.1v.1h-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M31.7 24.4h.1v.1l.2.2h.2l.2-.2-.1-.2H32l-.2.1-.1-.1-.2-.1-.1-.1-.2.1-.1.1H31s0 .3-.1.2l-.2-.1h-.1l-.1.2v.2c.1 0 .2.1.4 0v-.1h.1l.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M31.5 24v.1h.1-.1l-.2.1v.1a.5.5 0 0 1-.2.1l-.1.1h-.3a.5.5 0 0 1 0-.1.1.1 0 0 0-.1 0 4 4 0 0 0 0 .1h-.1v.2c.1.1.2.2.4.1a.1.1 0 0 0 0-.1v.2h-.3l-.1-.2v-.2l.2-.1m0 0 .2.1h.1a.2.2 0 0 0 0-.1m.3-.2.2-.1m-.2.1Zm-.3.4h.1a2.7 2.7 0 0 1 .2-.2l-.1.1-.2.1m.8-.3h-.1v-.1m0 .1h.1l.1.1h.1v-.1a.3.3 0 0 1 .1 0h.2a.2.2 0 0 1 0 .1h.1l-.2.3H32a.5.5 0 0 1-.1 0 .3.3 0 0 1-.1-.2m0 0h-.2.1m0 0a.3.3 0 0 0 .2.2.5.5 0 0 0 .1 0h.1l.2-.2v-.2h-.1a.4.4 0 0 0-.2 0l-.1.1h-.1l-.1-.1h-.1v-.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "M31.5 23.5v.7h-.3v-.3l.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M31.1 23.9a2.4 2.4 0 0 0 0 .3h.1a.3.3 0 0 0 .2 0l.1-.1a.8.8 0 0 0 0-.2v-.4l-.4.4Zm0 0a2.4 2.4 0 0 0 0 .3h.1a.3.3 0 0 0 .2 0V24a.8.8 0 0 0 0-.2v-.4l-.2.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C83C",
    d: "m31.2 24.4.1.1h.1v-.1l.2.1c.1 0 0-.1 0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    fillRule: "evenodd",
    d: "M31.7 24.4v.1h-.4m.4-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202220",
    d: "M30.1 24.7v-.2h.2v-.2l-.3.1.1.3Zm.5.5v-.6c-.1 0-.3.1-.3.3a.3.3 0 0 0 .3.3Zm1.7-.2s.3.1.3-.2c0-.2-.1-.3-.2-.3l-.2.2.2.1-.1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B4139",
    d: "M30.6 25.2s-.3-.1-.3-.4l.2-.2s-.2 0-.2.2c0 .3.3.4.3.4Zm-.5-.5-.1-.3c0-.2.3-.2.3-.2s-.3 0-.3.2l.1.3Zm2.2.3h.1l.2-.1v-.3l-.2-.1h.1c.1.1.2.2.1.4l-.2.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#904720",
    d: "m28.4 18 .1-.1h.4l.2.2-.4.2-.1-.2h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M31.6 23v-.5l-1.4.4.5.5.9-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2A567",
    d: "m29 22.1-.1-.2h-.1v.4h.3v.2h.1V22Zm0 .2.1.1v.1l.1.2-.5-.1v-.2h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2A567",
    d: "M29.3 22.7h.1v-.8l-.4-.4v.7l.1.3.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "M29 21.7v.2l.2.7-.1-.2-.2-.8c0-.3.1.1.1.1Zm.3.3-.1.2v.2-.1l.1.2V22Zm0 .9-.4-.1c-.2 0-.3-.2-.3-.2h.4l.2.1h.3v.1l-.2.1Zm-.7 0s.1 0 0 0h-.1l.4.1-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2A567",
    d: "M28.5 22.7h.2c.1.1.2 0 .2 0v.1h.1v.1h-.3l-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "m29.4 22.5.1.1v-.5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "M29 22.1V22l-.2-.3v-.1l.2.1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2A567",
    d: "m28.2 22.9.2-.1h.2l.2.1.1.1h-.5l-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "M29.4 22v.4l.1.2v.1h-.3.2v-.3l-.1-.2V22l.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "M28.6 22.8c0-.1 0 0 .2 0h.4v.2h-.3v.1-.2h-.3v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "m29 22.1-.4-.5v-.5l.3.4v.2l.1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "M28.8 23.3V23l.7-.4v.3l-.6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "M28.9 23h.1l-.2-.1-.2-.1.2.1v.1Zm.8.1-.2-.2v-.2l-.3.2h.2l-.3.1h.3l-.3.1-.2.1v.1h.3l.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "m29.7 23.1-.2-.4V22l.1.2.2.2-.1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "M29.7 22.4v.7l.1.2.1-.2v-.3l-.2-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M30 22.8s0 .5-.2.6l-.1-.3.1.2.1-.6Zm-.3.3h-.1l-.3.1h-.5s.1.2.5 0h.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "m29 22.4.2.1v.2-.2l-.2-.3v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "M28.9 23.1V23h-.3l-.4-.1.3.1h.3v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m28.9 23.1-.4-.1-.3-.1.3.1.4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "m29 22.3-.3.1-.1.2h.1v-.2h.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "m28.6 22 .2.1.2.1v.2l-.3-.2V22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "M28.9 22h-.3l.1.1V22h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m29.7 21.7 1.5-.8.8 1-1.4.4H30l-.4-.2.2-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "m31.8 22.1 2 1.7-.3.2-.4-.2-1-1-.3-.3v-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "m34.3 23.5-1.1-.9-1.4-1v.5l1.6 1.5.6.2h.2l.2-.2v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#803F1D",
    d: "m31.8 22.3 1 1c.4.3.8.6 1 .6v-.1l-2-1.7v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "M33.2 24h-.5l-1.2-1.3v-.2h.3l1.4 1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M34.3 23.5s-.1.3-.5.3c-.3-.1-2-1.8-2-1.8v.2s1.7 1.6 2 1.7c.4 0 .7-.3.7-.3l-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#803F1D",
    d: "M31.6 22.5s.5.8.8 1l.7.5c.1 0 0-.2 0-.2l-1-.8-.3-.5h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M31.7 22.5s1.4 1.5 1.6 1.5l.5-.2h-.1s0 .2-.4.1c-.3 0-1.5-1.4-1.5-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "m32.3 24-.6-.7v-.2l-.1-.2 1 1-.1.1h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m33.2 24-.3.1c-.1 0-.2 0-.3-.2l-1-1L33 24l.2-.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M32.6 24h-.3l-.6-.8v-.1l.7.9.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B07229",
    d: "m32 22 .6.5.3.1h-.1l.3.3h.3l-.2.1.3.3h.4-.3l.5.4-.6-.3v.2-.3l-.4-.2v.1-.2l-.4-.3v.2-.2L32 22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "m31 23.7-.1.2-.3-.4v-.4l.2.3.2.3Zm.8-.2V23l-.1-.2h-.4v.5l.1.2h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "M31.6 24v-.4l-.3-.4V23h-.2v.2l.2.4c0 .1.2.4.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m31.4 23 .1.2.1.4.2.2v-.3h-.1l-.1-.4v-.3l.1.5h.1v-.2l-.1-.3v-.2l.2-.1v-.6l-.7.8.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M31.4 22.9v.5l.2.2v.3l-.2-.6-.1-.3h-.1l.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "M31.4 24v-.2l-.3-.5-.2-.2-.2-.2v.4l.3.5.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M30.4 23v.4l.2.3.3.3v-.2.1l-.3-.6v-.1l-.2-.1Zm.7.6-.2-.3V23l-.1-.2.1.2h.2v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C3A1D",
    d: "m30.7 23.3.1.2.2.3-.2-.3-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M31.1 23.1h.1l.1-.1-.1-.1-.1-.1v.2Zm0 0 .2.6v.3-.3l-.2-.4v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "M31.3 23v-1l-.2-.5H31l-.3-.1v.4l.5 1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8B441F",
    d: "M30.4 23.3c.1 0 .1-.1 0-.2l-.7-1 .7 1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8B441F",
    d: "M30.8 23v.3c-.2 0-.9-1-1-1l-.4-.4.4.1 1 .9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C3A1D",
    fillRule: "evenodd",
    d: "M29.4 22a2.2 2.2 0 0 0 .4.3l.1.1a12.8 12.8 0 0 0 .8.9V23a.6.6 0 0 0 0-.1v-.1l-.9-.9a3.7 3.7 0 0 0-.4 0Zm.4 0 1 .9v.4h-.4a4.5 4.5 0 0 1-.5-.7l-.2-.2a4.1 4.1 0 0 1-.4-.4h.2a3.7 3.7 0 0 1 .2.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m30.4 23.3-.1-.2v-.2l-.6-.8-.2-.1v.2l.4.5.5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "M31 23.2c.2 0 .1-.3.1-.4l-.4-.9h-.4v-.2.4l.3.6.5.5Zm.5-.5.1-.2v-.4l-.3-.8h-.1L31 21v.5l.3.8v.2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m30.7 22.9-.3-.4-.2-.3H30l-.2-.2.3.5c.5.5.6.4.6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8B441F",
    d: "M31.3 23c.2 0 .2-.5 0-.8 0-.4-.2-.6-.2-.6l.2.7v.3l-.1-.3-.2-.3.2.9-.5-1s.4 1.2.6 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "m31.6 20.7.2.4v1.5h-.2l-.1-.9-.2-.7v-.1l.1-.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8B441F",
    d: "M31 23.2c.2 0 0-.2 0-.2l-.1-.3v-.1l-.2.1-.4-.6s.4 1.1.8 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M30.9 22.7v-.3a3 3 0 0 0-.2-.5h-.4l.6.8Zm.2-.2-.1-.6-.3-.4v.3s.2 0 .3.2l.1.5Zm.4-.6v-.5l-.1-.5.1.2v-.3h-.1c0 .1 0 0-.1 0v.4l.1.4.1.3Zm.4 0-.1-.8-.2-.4.2.6v.6Zm-.6.3v-.7l-.2-.3V21v.5l.1.2.1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#904720",
    d: "M31.6 22.8V22a19.3 19.3 0 0 0 0 .2l-.2-.3.1.6v-.1.1l.1.2Zm.1-.3c.1 0 0-.5 0-.8l-.2-.7.2.7v.9-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#312317",
    d: "M30.8 23.1v.2c-.2 0-.3-.2-.4-.3l.3.3V23l.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2A567",
    d: "M31.3 20.6h.2a.4.4 0 0 0 .2-.3v-.2c-.1 0 0 0 0 .2s0 .4-.2.5h-.1v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "m31.1 20.1.2.5v.3L31 20Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2121",
    d: "m28.5 20.4 1 1.5 1.2-1.4-.7-.8-1.5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "M29.8 19.5v.7l.2.2.3.1v-.4h.4l.3-.4-.1-.2-.3-.4v.2h-.5l-.1.2-.3-.1v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C3818",
    d: "M30.3 20.5v-.7l-.1-.4.1.6v.5c-.2 0 0 0 0 0Zm0-.5s.2.2.3.1v-.5l-.1-.3v.3l.1.5h-.3v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "M29.8 20.1h.2v.1l.2.2v.2l-.3-.1v-.1l-.1-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2A567",
    d: "M30.2 22.2s-.3 0-.4-.2l-.6-.6V21h.1l.4-.1v-.1l.5-.3h.2l.6-.1v-.3l.3.5v.5L31 21s.2.5 0 .5l-.3-.2v.5a1 1 0 0 1-.5-.2v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "m30 21.5.2.2v.3s-.2-.1-.2-.3l-.2-.3.3.1Zm1.1-1.2.1.8-.4-.3-.4-.6h.2l.5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "m29.8 21.8-.2-.2-.2-.3-.2-.2-.1-.1h.1l.6.4v.4Zm.8 0-.5-.4-.4-.5v-.2l.9 1Zm0-.4-.2-.2V21l.3.4Zm.3 0s-.3-.2-.4-.5l-.2-.2h-.1v-.1h.1v-.2l.5.8v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "M29.8 22a2 2 0 0 1-1-.7l-.3-.4.1-.2 1 1 .2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "M29.8 22c-.1 0-.3 0-.7-.4l-.5-.7v-.2l.7.9.5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "m30.4 21.6-.3-.3-.3-.5v-.2h.4l.2.3.2.4s-.2-.2-.3-.1l.2.4Zm-.3 0c0 .1 0 .2-.1 0l-.2-.2v.2l-.3-.3-.3-.4v-.4.1l.4.4h.1l.2.3.2.2Zm-1.3-.6.5.7.5.3-.7-1h-.3Zm2 .2-.3-.3a1 1 0 0 1-.1-.5v-.3l.3.4.1.3h-.2l.2.4Zm.3-.3-.2-.2v-.3l-.2-.3v-.3h.2l.2.2v.9Zm-2.1.8a4 4 0 0 1-.4-.6v-.3s0 .4.4.8l.5.3v.3l-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m29.4 22.1-.6-.6-.4-.6.1-.1c.2.5.5 1 .9 1.3Zm.4 0-.5-.7-.3-.4h.1l.2.4.5.6Zm0-.7-.3-.4-.2-.4.3.3h.1v.5Zm0-1v.3c0 .2.2.3.4.4L30 21l-.1-.3.2.1.3.3s0-.3-.2-.4a5 5 0 0 0-.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "m30.7 20.9-.2-.4-.2-.5v.6H30c-.1 0 0 0 0 0h.2v-.2l.2.3.2.2Zm-.4-.9s.2.2.3.1v-.3h.2v-.2l.3.5.2.6-.3-.6c0-.2-.2-.3-.2-.3v.3l.1.3.1.3-.1-.2-.2-.2h-.1l-.2-.1V20Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "m29.7 21 .4.5-.3-.3-.1-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "M31 21h-.2l.1.2h.2V21H31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2A567",
    d: "m28.7 19.6-.1.1-.2.3v.5l.3.3.4.3.1-.3v-.3l.2.2c0 .2.2.3.2.2l.2-.3-.3-1h-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "m29.5 20.4.1.3v.2l.3-.3-.1-.6v-.5l-.3.3v.6Zm-.6-.2v.4c0 .2.1.4.2.3l.1-.4V20l-.1-.4-.2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#45392D",
    d: "m28.4 19.5-.3.6v.4l.2.6v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "m28.4 19.5-.3.6.1.4.1.5h.2l.2-.2-.1-.2v-.2l-.2-.1v-.4l.1-.3h-.1v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBAD6C",
    d: "M29.7 20.2h-.1l-.1-.2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2A567",
    d: "m28.4 19.5-.2.7.2.7v-1l.1-.2v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "M28.9 19.6v.2l-.2.2v.3-.2s.1-.1.1 0v.5-.2l.2.2v-.2l.1-.2v-.5h.1l-.1-.3-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBAD6C",
    d: "M29.7 20.4h-.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "M28.5 20.5v.3-.3l-.1-.2V20h-.1v.2-.2l.2-.2v-.2l.2.2h-.1l-.1.4v.4Zm1-.8v.2l-.2.2v.2-.2l.2.1v.3-.1h.2l-.2-.2V20h.1l.2.2-.1-.1v-.6l-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2121",
    d: "M30.4 19.3c0 .2 0 .5.2.7l-.2-.4-.1-.3v.5l-.1-.2v-.2l-.1.2.1.3-.1-.1v.1l.1.2-.1-.1v-.1.3l.1.3-.2-.3v-.9l.2-.5.1.4.1.1Zm-.8 0h.1v.1l-.2.2-.2.2v-.1l.1-.2.2-.2Zm-1 .3.1.2.4-.3v-.1l-.4.2h-.1Zm0-.3v.2s-.2.1-.2 0v-.1h.1l.1-.1Zm2-.3v.3l.2.2-.2-.1-.1-.1V19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBAD6C",
    d: "M28.3 19.4h.2l.1-.1v.2l.1.1h.2c0-.2.2-.3.2-.3v.3c0 .1.1.1.2 0l.3-.2v-.1l.1-.1.1-.5v-.1h-.4l-.1.1H29l-.1-.1-.3.2-.2.2-.1.1-.1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "M29.4 18.9v.3l-.2.4s.3-.1.4-.4v-.5l-.2.2Zm.3-.2v.6l.2.2.2-.2V19h.1l.1.2s.1.2.2.1l-.1-.5-.1-.3-.1-.2h-.3l-.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "M30.2 18.3v.7-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "M30.5 19v.2l-.2-.3v-.4l-.1-.2h.1l.2.7Zm-.6.4s.2-.1.3-.6l-.2-.5v.6l-.2.4.1-.2v.3Zm-.2-.7-.2.2-.3.1.2-.2v-.2.1h-.2l.1-.1.1-.2.1.1.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2121",
    d: "m30.4 18.1.1.9-.1-.3-.1-.3H30v-.2h.5Zm-.5 1 .1-.5v-.3l-.2-.2v.3l-.1.3c.2-.1.2-.3.2-.3v.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "m28.2 19.4.2-.3.2-.3a.3.3 0 0 0 .3-.2l.1-.2v.3h.2v.3l-.1.3V19l-.1.1-.1.2V19c.1 0 0 0 0 0v-.2l.1-.1-.1.1-.1.3-.1.3v-.2l.1-.4-.3.3v.3h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#874F20",
    d: "M30.5 18v.1h-.3V18h.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B27129",
    d: "M28.7 18.3v.2l-.2.2s0 .1.1 0l.1-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBAD6C",
    d: "m29.8 18-.1.7c-.2 0-.3-.3-.3-.3s0 .4-.2.4l-.2-.4-.1.3c-.3.2-.4 0-.4 0s.2-.1.2-.4h.1l.1-.2h.3l.1-.2h.1l.2-.2.2.2v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B27129",
    d: "m29.2 17.5.2.4.1-.1v.5-.2l.1-.1v.5l.2-.4c0-.2 0 0 0 0s.2.3.3.2l.1-.3v-.3l-.6-.4v.2h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "M30 17.4v.2c.1.2.2.6 0 .6l-.2-.1v-.4l-.1-.2v-.2h.1l.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "m30 17.3.2.4.2.3h.1a.2.2 0 0 1-.3 0l-.1-.4-.3-.3h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2121",
    d: "m29.8 17.1.3.3.2.4.2.2-.2-.1-.2-.4-.3-.2.2.2v.3-.2l-.3-.3.2.3v.3-.3l-.2-.2-.2-.1h.2l.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "M29.3 17.5h.3v.4-.2l-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B27129",
    d: "M29.4 17.9v.3l-.2.5v-.4l-.1.1v-.3l.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "m29 18-.2.2h.1l-.2.4.2-.3.1-.2h.1l.1.3.1-.3V18l-.2-.1v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBAD6C",
    d: "M29.8 17s.1 0 0 .2h-.3L29 17v-.1h.5l.1.1h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "M29.8 17s0 .1-.2 0h-.3a1 1 0 0 0-.3-.1h-.1.4l.4.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "M28.8 16.8h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBAD6C",
    d: "M29.6 17.3v.2l-.2-.1-.4-.2h-.2V17h.3l.3.1.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBAD6C",
    d: "m29.3 17.5.2.4-.6-.4-.2.3-.4-.2.4-.3h.5v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "m29.2 17 .3.1.2.1h-.3L29 17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "M28.8 17h.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "M29.6 17.4v.1h-.2l-.2-.2h-.4v-.1h.4l.3.1.1.1Zm-.5.2v.4h-.2v-.1l-.2-.1.1-.2c.1 0 0 0 0 0h.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "M28.8 17.1h.1l.2.1h.1l.2.1.2.1h-.2l-.3-.1h-.4v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "M29.4 17.8s.1 0 0 0h-.3v-.1l-.2-.2c-.1 0 0 0 0 0l.3.1.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "M29.4 17.8s0-.2-.4-.3l-.3-.1h-.1.2l.1.2s-.1.2 0 .2v-.1h.2l-.1-.2.3.1.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBAD6C",
    d: "M28.9 17.5s.2.1.2.4c0 .3-.2.2-.2.1h.1v-.4h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C3F18",
    d: "M27.7 16.9v.2l-.2.4-.3.3c0 .1.1 0 .1 0l.4-.5.1-.3v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBAD6C",
    d: "M28.7 16.5s.1.1 0 .4c0 .4-.4.6-.4.6l-.6.4h-.3l-.1-.1v-.1l.3-.3.1-.1v-.4h.1v.4l.2-.1.2-.1V17l.1-.4v-.2l.1.2v.3l.2-.1v-.2l.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#904720",
    d: "M28.8 18v.2l-.2.1v-.2h-.2l.2-.2.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "M28.7 18c.1 0 .2 0 .1-.1v.1l-.2-.1h-.2.2v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#904720",
    d: "M27.8 17.6h.2l.2-.1.2-.1s.3-.2.3-.5v-.4s.3.3 0 .7l-.3.4h.3v.2l.2.1h-.4l-.2.1h-.9l.2-.3.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "m28.5 16.8.2-.2v-.1.2l-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#904720",
    d: "M28.4 16.6v.5c0 .2-.6.4-.6.4l.5-.4.1-.4v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2121",
    d: "M28 17.6h.2l.2-.2h-.1l-.2.1-.1.1Zm.3-.5s.2-.1.2-.4c0-.3-.2-.3-.2-.3l.1.3v.4Zm.2 0 .2-.1v-.3.3l-.2.1Zm-.1 1s0-.2.2-.2v.1h-.2Zm-.3-.3.4-.1.2-.1-.2.2h-.3l.3-.1h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.8 17.4v.3a.3.3 0 0 1-.3.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F16E16",
    d: "M27.8 17.4v.3a.2.2 0 0 1-.3.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.7 17.6v.1h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5D3CA",
    d: "M27.7 17.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "m27.8 17.3.2-.4v-.3l.1.1v.4h.1c0-.1.2-.5.1-.7v.4c0 .3 0 .3-.3.4-.1.1-.3.2-.3.4l-.2.3.1-.3.2-.2v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#904720",
    d: "M27.8 17.4v-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2A15",
    d: "m28 17.1.1-.2v-.3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB6D29",
    d: "M27.4 18v-.4l.3-.3s.1-.3 0-.4c0 0 .1.2 0 .4l-.3.3-.1.2v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C4119",
    d: "M28.6 18.3c.1 0 .1 0 0-.1l-.1-.1h-.2.3v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C4119",
    d: "M28.6 18.3s.2 0 .2-.2h.1s0 .2-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BF802D",
    d: "M27.6 18.3h.1l.1.2.3-.1.2-.1-.1-.2h-.3l-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9C83A",
    d: "M28.5 18.2V18h-.7l-.3-.1h-.2l-.2-.1H27v.2s-.3.1-.3.4c0 .2.4.6.6.4 0 0-.3-.2-.2-.3 0-.2.1-.3.3-.3h.3c.1-.2.3-.2.4 0l-.4.2.7-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    fillRule: "evenodd",
    d: "M27.4 17.9a.5.5 0 0 0-.1 0H27a.1.1 0 0 0 0 .1l-.2.2-.2.3.1.2.2.2.2.1h.2a.8.8 0 0 1-.1-.2l-.1-.1v-.1l.1-.2h.2l.2-.1h.1c.1-.1.3-.2.4 0H28a2.2 2.2 0 0 1-.2.2v.1a3 3 0 0 0 .7-.3V18h-.2a1.1 1.1 0 0 0-.2-.1h-.5l-.2-.1Zm.5.2-.3-.1h-.2a1.1 1.1 0 0 0-.1-.1 1 1 0 0 0-.2 0v.2a.7.7 0 0 0-.2.1l-.1.3v.2l.2.2h.3l-.1-.2v-.3l.3-.1h.3v-.1c.1 0 .3-.1.4 0v.1l-.2.1a2.2 2.2 0 0 1-.2.1 1.6 1.6 0 0 0 .1 0 4.2 4.2 0 0 0 .5-.2V18h-.1a1.1 1.1 0 0 0-.2 0h-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCF3D8",
    d: "M27.1 18.8s-.3 0-.2-.3c0-.3.2-.4.3-.4v-.2a.2.2 0 0 1 .2 0l.2.1s-.5.3-.5.6v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDEAAF",
    d: "m28.5 18.2-.3-.2H27l.2-.1.5.1h.3c.2 0 .4 0 .4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#513625",
    d: "m27.7 18.4.2-.1h.2-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9C83A",
    d: "m27.3 19-.3-.1a.6.6 0 0 1-.2-.3l.1-.4.2-.1-.2.1v.5l.2.2h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8B5122",
    d: "M27.2 18H27h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9C83A",
    d: "m27.7 18.2-.4.1h.4c.2 0 .5-.2.5 0l-.4.1v.1h.3l.2-.2-.1-.2h-.3l-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "m27.2 18.7.1.2h-.2s-.2 0-.3-.3v.1l.1.2h.4l-.2-.3v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCCA3D",
    d: "M28.3 21.8v.1-.1Zm-.4-3.2-.1-.2h-.1l.1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#816C2A",
    d: "M28.3 22H28h.2l.2.1Zm0-.2H28h.2Zm0-.3-.3.2v.1l.3-.2Zm-.2-.2v.2l-.3.2.2-.2h.1v-.2Zm-.2-.1v.4h-.1v.1l.1-.3v-.2Zm-.2 0v.4-.5Zm-.1 0v.2l-.1.3v-.3l.1-.3Zm-.2 0v.5-.5Zm-.1 0v.2l-.1.2v-.2l.1-.2Zm-.2 0v.2l-.1.2h-.1l.2-.1v-.3Zm0 0-.1.2h-.2v.1l.2-.1v-.2Zm-.2-.1v.1h-.2v.1h.1l.1-.1V21Zm0-.1-.2.1v.1l.2-.2Zm-.1 0h-.1.1Zm0-.1h-.1Zm0-.1h-.1Zm0-.3-.1.1v.1-.1Zm1-1.1h.1-.1Zm0-.1.1-.1h.1-.2Zm0-.2h.1l.1-.1h-.2v.1Zm-.1-.1.1-.1.2-.1h-.2l-.1.2Zm0-.2.2-.2-.3.2Zm-.2-.1.3-.2h-.2l-.2.2Zm-.1-.1.2-.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78732E",
    d: "m27.6 18.3.3.3.1.3c0 .3 0 .4-.2.6l-.7.6-.3.3a.6.6 0 0 0 0 .6.4.4 0 0 0 .4.2h.5l.4.1c.2.1.2.4.2.6a2.3 2.3 0 0 1 0 .5V22l-.1-.6a.5.5 0 0 0-.5-.2h-.5a.4.4 0 0 1-.3-.1l-.1-.3c0-.2 0-.3.2-.4l.6-.6c.2-.2.4-.4.4-.7 0-.2 0-.4-.2-.5l-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8AC71",
    d: "M27.4 18.6Zm0 0v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78732E",
    d: "M27.6 18.8Zm.1.2Zm0 .1Zm0 .2Zm0 0Zm-1 1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.6 20.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78732E",
    d: "M26.6 21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.6 21Zm0 .2Zm0 .1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8AC71",
    d: "M26.8 21.5Zm.1.2Zm1 0h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28 21.8h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8AC71",
    d: "M28 21.8Zm0 .2c0-.1 0 0 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.9 22.1Zm-1.4-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9C83A",
    d: "M27.6 18.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F4620",
    d: "M27.7 18.3h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#977C2E",
    d: "M28.2 22.4Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.326 .138 -.138 .327 27.5 23.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15770"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.033 -.35 .325 -.03 25.1 22.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15770"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.118 .14 -.276 .23 34 24.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15770"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsMx);
export default __webpack_public_path__ + "static/media/es-mx.ddeb5653107c5e1a0826c8d2b629459a.svg";
export { ForwardRef as ReactComponent };